import * as React from 'react'
import { FormattedMessage } from 'react-intl'
import { FaShippingFast } from 'react-icons/fa'

import styles from './DeliveryInfo.module.scss'

const DeliveryInfo = () => {
  return (
    <div className={styles.wrapper}>
      <div className={styles.row}>
        <FaShippingFast size="1.1em" />
        <p>
          <FormattedMessage
            id="Product.DeliveryInfo.freeShippingText"
            defaultMessage="Fri frakt 1-4 dagar"
          />
        </p>
      </div>
    </div>
  )
}

export default DeliveryInfo
